import type { UpdateReportTemplateRequestUpdateSheetConfiguration } from '~/server_shared/openapi/data-contracts';

export type SheetFormValue = Omit<UpdateReportTemplateRequestUpdateSheetConfiguration, 'metabase_question_id'> & {
  metabase_question_id: number | null; // Nullable for form state (before selection)
};

export interface FormValues {
  templateName: string;
  sheets: SheetFormValue[];
}

export interface SheetValidationState {
  matchedVariables: string[];
  unmatchedVariables: string[];
  isValidating: boolean;
  extracted_variables: string[];
  // Display names of the selected question's columns, offered as click-to-copy tokens.
  availableColumns?: string[];
}

export type SheetsValidationState = Record<string, SheetValidationState>;

type ConfiguredSheet = SheetFormValue & { metabase_question_id: number };

export function isConfiguredSheet(sheet: SheetFormValue): sheet is ConfiguredSheet {
  return sheet.metabase_question_id !== null && sheet.display_name.trim() !== '';
}
